import * as yup from 'yup'

export const approvalManagerSchema = yup.object({
  approvalManagers: yup
    .array()
    .of(
      yup.object({
        id: yup.string(),
        name: yup.string().required('Name is required'),
        phoneNumber: yup
          .string()
          .required('Mobile number is required')
          .matches(/^\+?\d{7,15}$/, 'Enter a valid mobile number'),
      }),
    )
    .required('At least one approval manager is required')
    .test('unique-mobiles', 'Mobile numbers must be unique', (value) => {
      if (!value) return false
      const mobiles = value.map((entry) => entry.phoneNumber)
      const uniqueMobiles = new Set(mobiles)
      return mobiles.length === uniqueMobiles.size
    })
    .test('unique-name', 'Names must be unique', (value) => {
      if (!value) return false
      const names = value.map((entry) => entry.name)
      const uniqueNames = new Set(names)
      return names.length === uniqueNames.size
    })
    .min(1, 'At least one approval manager is required'),
})

export type ApproverManagerConfigFormFields = yup.InferType<
  typeof approvalManagerSchema
>
